export type {
  MenuGroupHeaderProps,
  MenuGroupHeaderSlots,
  MenuGroupHeaderState,
} from './components/MenuGroupHeader/index';
export {
  MenuGroupHeader,
  menuGroupHeaderClassNames,
  renderMenuGroupHeader_unstable,
  useMenuGroupHeaderStyles_unstable,
  useMenuGroupHeader_unstable,
} from './components/MenuGroupHeader/index';
